<template>
  <div class="business-data container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        node-key="key"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :default-checked-keys="checkedKeys"
        show-checkbox
        :expand-on-click-node="false"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
        @check="handleTreeNodeCheck"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="数据记录" name="0">
            <el-form ref="dataQueryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleDataFormQuery()">
              <el-form-item label="告警状态" class="right-vertical-line pr15">
                <el-checkbox-group v-model="dataTableQueryParams.alarmStates">
                  <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">
                    {{alarmState.name}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="数值更新时间">
                <uni-date-range-picker
                  v-model="dataDates"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </uni-date-range-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleDataFormQuery()" type="primary">查 询</el-button>
                <el-button @click="resetDataQueryForm()">重 置</el-button>
              </el-form-item>
            </el-form>
            <div class="chart-container">
              <div class="chart-title">数值变化趋势</div>
              <LineChart
                ref="dataLineChart"
                :id="dataLineChartId"
                :source="dataLineChartData"
                :color="dataLineChartColor"
                style="width:100%; height:calc(100% - 50px); min-height: 340px"
              ></LineChart>
            </div>
            <div class="pagination-table-container">
              <el-table :data="dataTableData"
                        ref="dataTable"
                        v-loading="loading"
                        border highlight-current-row
                        element-loading-background="rgba(255, 255, 255, 0.8)"
                        element-loading-spinner="el-icon-loading"
                        element-loading-text="努力加载中..."
                        style="width:100%;min-height:250px;height:250px;overflow-y:auto"
                        @selection-change="handleDataTableSelectionChange">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                  <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
                </el-table-column>
                <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
                <el-table-column label="告警状态" prop="alarmState" width="80">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                      {{scope.row.alarmStateText}}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
                <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
                <el-table-column label="数值更新时间" prop="reporttime" width="160">
                  <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.reportTime)}}</template>
                </el-table-column>
                <el-table-column label="正常区间" prop="" width="120">
                  <template slot-scope="scope"> {{$type.getDataNodeAlarmRuleText(scope.row)}}</template>
                </el-table-column>
                <!--                <el-table-column label="操作" width="100">-->
                <!--                  <template slot-scope="scope">-->
                <!--                    <el-button-->
                <!--                      class="col-btn"-->
                <!--                      type="text"-->
                <!--                      icon="el-icon-view"-->
                <!--                      @click="handleDataView(scope.row)"-->
                <!--                    >查看-->
                <!--                    </el-button>-->
                <!--                  </template>-->
                <!--                </el-table-column>-->
              </el-table>
              <el-pagination
                             background
                             @current-change="handleDataCurrentPageChange"
                             @size-change="handleDataPageSizeChange"
                             :current-page.sync="dataTableQueryParams.pageNum"
                             :page-sizes="[5, 10, 15, 20, 30, 50, 100, 200, 300, 500, 1000]"
                             :page-size.sync="dataTableQueryParams.pageSize"
                             prev-text="上一页"
                             next-text="下一页"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="dataTableTotalRow">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import BusinessData from './BusinessData.js'

export default BusinessData
</script>

<style lang="scss">
// @import "BusinessData.scss";
</style>



// WEBPACK FOOTER //
// src/views/events/BusinessData/BusinessData.vue